import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import App from "./App";
import { captureReferrer } from "./referral";

// a referral link on any page counts for every game
captureReferrer();
window.addEventListener("hashchange", captureReferrer);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);


serviceWorkerRegistration.register();

// a new deploy's service worker takes over right after it installs: reload once so the page runs the new build.
// The browser only looks for it when the page loads, so this happens in the first seconds of a visit.
// No reload on a first visit, when the service worker just starts controlling the page.
if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
	let reloading = false;
	navigator.serviceWorker.addEventListener("controllerchange", () => {
		if (reloading) return;
		reloading = true;
		window.location.reload();
	});
}